import styled from 'styled-components';

export const Item = styled.li`
  display: flex;
  justify-content: space-between;

  margin-bottom: 8px;

  button {
    padding: 0 10px;
  }
`;
